import { render } from "./UsuariosView.vue?vue&type=template&id=f5c723be"
import script from "./UsuariosView.vue?vue&type=script&lang=js"
export * from "./UsuariosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__